'use client';

import { useKlaviyoIdentity } from './useKlaviyoIdentity';

/**
 * Klaviyo Provider Component
 *
 * This client component handles Klaviyo initialization without
 * breaking the App Router by turning the entire layout into a client component.
 *
 * Usage:
 * ```tsx
 * // app/layout.tsx (stays SERVER component)
 * import { KlaviyoProvider } from '@/lib/klaviyo';
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         <KlaviyoProvider />
 *         {children}
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 */
export function KlaviyoProvider() {
  useKlaviyoIdentity();
  return null;
}
